module.exports = __webpack_public_path__ + "img/1203.e520ec6e.jpg";